import { CLEAR_ERROR, CREATE_COA_FAIL, CREATE_COA_REQUEST, CREATE_COA_RESET, CREATE_COA_SUCCESS, GET_ALL_PRODUCTS_FAIL, GET_ALL_PRODUCTS_REQUEST, GET_ALL_PRODUCTS_SUCCESS, GET_COA_FAIL, GET_COA_REQUEST, GET_COA_SUCCESS, GET_COAs_FAIL, GET_COAs_REQUEST, GET_COAs_SUCCESS, GET_CREATED_BY_FAIL, GET_CREATED_BY_REQUEST, GET_CREATED_BY_SUCCESS, GET_SELECT_PRODUCT_FAIL, GET_SELECT_PRODUCT_REQUEST, GET_SELECT_PRODUCT_RESET, GET_SELECT_PRODUCT_SUCCESS, UPDATE_COA_FAIL, UPDATE_COA_REQUEST, UPDATE_COA_SUCCESS } from '../constants/productConstant'


export const getProducts = (state = { data: [] }, action) => {
  switch (action.type) {
    case GET_ALL_PRODUCTS_REQUEST:
      return {
        loading: true,
      };

    case GET_ALL_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        products: action.payload.products,

      };

    
    case GET_ALL_PRODUCTS_FAIL:
      return {
        ...state,
        loading: false,
        products: null,
        error: action.payload,
      };

    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
export const getCreatedBy = (state = { data: [] }, action) => {
  switch (action.type) {
    case GET_CREATED_BY_REQUEST:
      return {
        loading: true,
      };

    case GET_CREATED_BY_SUCCESS:
      return {
        ...state,
        loading: false,
        createds: action.payload.createds,

      };

    
    case GET_CREATED_BY_FAIL:
      return {
        ...state,
        loading: false,
        products: null,
        error: action.payload,
      };

    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
export const select = (state = { data: [] }, action) => {
  switch (action.type) {
    case GET_SELECT_PRODUCT_REQUEST:
      return {
        loading: true,
      };

    

    case GET_SELECT_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        product: action.payload.product,
        productId:action.payload.productId,
        success:true,
      };

    case GET_SELECT_PRODUCT_FAIL:
      return {
        ...state,
        loading: false,
        product: null,
        error: action.payload,
      };

      case GET_SELECT_PRODUCT_RESET:
        return {
          ...state,
          loading: false,
          success:false
        };

    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const getCoa = (state = { data: [] }, action) => {
  switch (action.type) {
    case GET_COA_REQUEST:
    case GET_COAs_REQUEST:
      return {
        loading: true,
      };

    case GET_COA_SUCCESS:
      return {
        ...state,
        loading: false,
        coa: action.payload.coa,

      };

    case GET_COAs_SUCCESS:
      return {
        ...state,
        loading: false,
        coas: action.payload.coas,
        totalCoa: action.payload.totalCoa,
        resultPerPage:action.payload.resultPerPage

      };

   

    case GET_COA_FAIL:
    case GET_COAs_FAIL:
      return {
        ...state,
        loading: false,
        products: null,
        error: action.payload,
      };

    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const createCoa = (state = { data: [] }, action) => {
  switch (action.type) {
    case CREATE_COA_REQUEST:
      case UPDATE_COA_REQUEST:
      return {
        loading: true,
      };

    case CREATE_COA_SUCCESS:
      case UPDATE_COA_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        coaId: action.payload.coaId,
      };

    case CREATE_COA_FAIL:
      case UPDATE_COA_FAIL:

      return {
        ...state,
        loading: false,
        success: null,
        error: action.payload,
      };
    case CREATE_COA_RESET:
      return {
        ...state,
        loading: false,
        success: null,
        error: null,
      };
    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};


